import React, { useState } from "react";
import {
  formatDateText,
  initialPaymentInfo,
  paymentMethodsData,
  restrictValue,
  transformPrice,
  usaStates,
} from "./data";
import {
  CheckedBox,
  FipayLogo,
  Footer,
  PageTitle,
  PayBtn,
  PaymentInfoWrapper,
  PaymentMethodWrapper,
  PaymentMethodsWrapper,
  UncheckedCircle,
} from "./PaymentInfo.styled";
import { PaymentInfoFormData } from "./types";
import PayWithCard from "./PayWithCard";
import PayWithAccount from "./PayWithAccount";
import { PageTitle1, PageTitle2 } from "./Confirmation";
import { BillingAddressInfo } from "./BillingAddress";
import StripeElementApp from "../StripeElement";
import { useStore } from "@nanostores/react";
import { paymentInfo as $paymentInfoAtom } from "../../store/nanostore";
import { brandSettings } from "../../store/nanostore";
import { PayWithBank } from "./PayWithBank";
import { useMutation } from "@apollo/client";
import {
  EditPaymentLink,
  MakePlaidTransferPayment,
} from "../../graphql/mutations/paymentlink";
import environment from "../../env";

interface PaymentInfoProps {
  handleNext: (step: number) => void;
  price: number;
}

const PaymentInfo: React.FC<PaymentInfoProps> = () => {
  const [selectedMethod, setSelectedMethod] = useState<string>(
    paymentMethodsData[0].key
  );

  const $paymentInfo = useStore($paymentInfoAtom);

  const handleSelectPaymentMethod = ({ method }: { method: string }) => {
    setSelectedMethod((prevMethod) => method);
  };

  console.log({ $paymentInfo });
  const renderPaymentScreens = (selectedMethod: any) => {
    switch (selectedMethod) {
      case "others":
        return <PayWithAccount data={$paymentInfo} />;
      case "pay-with-bank":
        return <PayWithBank />;
      case "pay-with-card":
      default:
        return (
          <StripeElementApp
            clientSecret={$paymentInfo?.paymentIntent?.clientSecret}
          >
            <></>
          </StripeElementApp>
        );
    }
  };
  return (
    <PaymentInfoWrapper>
      <PageTitle2 $small>Select payment method</PageTitle2>
      {$paymentInfo && $paymentInfo?.paymentIntent?.clientSecret && (
        <>
          <PaymentMethodsWrapper>
            {paymentMethodsData.map((data) => (
              <PaymentMethodWrapper
                key={data.label}
                onClick={() => handleSelectPaymentMethod({ method: data.key })}
              >
                <i>
                  {selectedMethod === data.key ? (
                    <CheckedBox />
                  ) : (
                    <UncheckedCircle />
                  )}
                </i>
                <div className={"flex"}>
                  <i>{data.icon}</i>
                  <span>{data.label}</span>
                </div>
              </PaymentMethodWrapper>
            ))}
          </PaymentMethodsWrapper>

          {renderPaymentScreens(selectedMethod)}
          {/*<BillingAddressInfo />*/}
        </>
      )}
      <Footer>
        Secured by <FipayLogo />
      </Footer>
    </PaymentInfoWrapper>
  );
};

export default PaymentInfo;
